import { httpClient } from './httpClient';
import { UserBookmarkItem, UserBookmarkListResponse } from '../types/userBookmark';

export const userBookmarkService = {
  async listMyBookmarks(eventId?: string): Promise<UserBookmarkListResponse> {
    const path = eventId
      ? `users/me/bookmarks?event_id=${encodeURIComponent(eventId)}`
      : 'users/me/bookmarks';
    return httpClient.get<UserBookmarkListResponse>(path);
  },

  async addBookmark(eventId: string, sessionId: string): Promise<UserBookmarkItem> {
    return httpClient.post<UserBookmarkItem>(
      `users/me/bookmarks/${encodeURIComponent(eventId)}/${encodeURIComponent(sessionId)}`
    );
  },

  async removeBookmark(eventId: string, sessionId: string): Promise<void> {
    return httpClient.delete(
      `users/me/bookmarks/${encodeURIComponent(eventId)}/${encodeURIComponent(sessionId)}`
    );
  },
};
